module.exports = __webpack_public_path__ + "img/milk.cc3ccdf5.png";